var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"2"}},[_c('div',{staticClass:"pa-6 text-center grey lighten-2 rounded-0",domProps:{"textContent":_vm._s(".rounded-0")}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }